import { ReactElement } from "react";
import { generateCoord } from "../Targets/Generators";

const STARS: Array<ReactElement> = []; // holds all stars

// generates starts
for (let i = 0; i < 500; i++) {
  STARS.push(
    <mesh
      key={"star " + i}
      position={generateCoord(-70, 70, -40, 40, -20, -70)}
    >
      <sphereGeometry attach="geometry" args={[0.075, 16, 16]} />
      <meshStandardMaterial attach="material" color={"white"} />
    </mesh>
  );
}

export default function Stars(): ReactElement {
  return <>{STARS}</>;
}
